import { render, staticRenderFns } from "./FeedBackContacts.vue?vue&type=template&id=1e59b956&scoped=true"
import script from "./FeedBackContacts.vue?vue&type=script&lang=js"
export * from "./FeedBackContacts.vue?vue&type=script&lang=js"
import style0 from "./FeedBackContacts.vue?vue&type=style&index=0&id=1e59b956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e59b956",
  null
  
)

export default component.exports